{
  "name": "@unibyte/admin",
  "version": "0.1.0",
  "private": true,
  "type": "module",
  "description": "UNIBYTE Chatbot admin dashboard (React + Vite)",
  "scripts": {
    "dev": "vite",
    "build": "vite build",
    "preview": "vite preview",
    "typecheck": "tsc -p tsconfig.json --noEmit",
    "test": "vitest run"
  },
  "dependencies": {
    "@unibyte/contracts": "workspace:*",
    "@unibyte/i18n": "workspace:*",
    "lucide-react": "1.61.0",
    "react": "19.3.1",
    "react-dom": "19.3.1",
    "react-router": "7.18.4",
    "swr": "2.5.1",
    "zod": "4.6.7"
  },
  "devDependencies": {
    "@tailwindcss/vite": "4.3.3",
    "@types/react": "19.3.0",
    "@types/react-dom": "19.3.0",
    "@vitejs/plugin-react": "6.1.2",
    "tailwindcss": "4.3.3",
    "typescript": "6.0.3",
    "vite": "8.3.5",
    "vitest": "5.0.5"
  }
}
